// src/constants/specialties.js
export const SPECIALTIES = [
  'General Physician',
  'Cardiologist',
  'Neurologist',
  'Orthopedic Surgeon',
  'Dermatologist',
  'Endocrinologist',
];